import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async publishSelected(event) {
    event.preventDefault()
    
    const channelSelect = document.getElementById('channel-select')
    const channelId = channelSelect?.value
    const checkedBoxes = this.element.querySelectorAll('input[name="image_ids[]"]:checked')
    
    if (!channelId) {
      alert('Wybierz kanał Discord')
      return
    }
    
    if (checkedBoxes.length === 0) {
      alert('Wybierz grafiki do publikacji')
      return
    }

    // Get current filter to determine button text
    const urlParams = new URLSearchParams(window.location.search)
    const filter = urlParams.get('filter') || 'new'
    const isPublished = filter === 'published'

    // Show overlay spinner
    this.showOverlay(isPublished ? 'Publikuję ponownie...' : 'Publikuję...')

    const imageIds = Array.from(checkedBoxes).map(cb => cb.value)

    try {
      const response = await fetch("/discord/publish", {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.getCsrfToken(),
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          channel_id: channelId,
          image_ids: imageIds
        })
      })

      const data = await response.json()
      
      this.hideOverlay()
      
      if (data.success) {
        // Reload after short delay
        setTimeout(() => window.location.reload(), 500)
      } else {
        alert('Błąd: ' + data.error)
      }
    } catch (error) {
      console.error("Error publishing:", error)
      this.hideOverlay()
      alert('Wystąpił błąd podczas publikacji')
    }
  }

  showOverlay(text) {
    const overlay = document.createElement('div')
    overlay.className = 'pokeball-overlay'
    overlay.id = 'publish-overlay'
    overlay.innerHTML = `
      <svg class="pokeball-spinner" aria-hidden="true" viewBox="0 0 1 1"><use href="#pb-standard"/></svg>
      <div class="pokeball-overlay-text">${text}</div>
    `
    document.body.appendChild(overlay)
  }

  hideOverlay() {
    const overlay = document.getElementById('publish-overlay')
    if (overlay) {
      overlay.remove()
    }
  }

  getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
